import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import {
	DataProvider,
	useStore,
	useSettings,
} from './trip-finder/context/store';

import useGetPosts from './trip-finder/methods/useGetPosts';
import useGetTaxonomies from './trip-finder/methods/useGetTaxonomies';
import Search from './trip-finder/components/Search';
import Posts from './trip-finder/components/Posts';
import Taxonomies from './trip-finder/components/Taxonomies';
import DatePicker from './trip-finder/components/DatePicker';
import LoadMore from './trip-finder/components/LoadMore';
import SortBy from './trip-finder/components/SortBy';
import NoResults from './trip-finder/components/NoResults';

function TripFinder(props) {
	const { state, dispatch } = useStore();

	const settings = useSettings();

	const { getPosts } = useGetPosts();

	const { getTaxonomies } = useGetTaxonomies();

	useEffect(() => {
		getPosts(settings.postsPerPage);
	}, [
		state.searchQuery,
		state.selectedTaxonomies,
		state.selectedStartDate,
		state.selectedEndDate,
		state.sortBy,
	]);

	useEffect(() => {
		getTaxonomies();
	}, [state.init]);

	useEffect(() => {
		mobileMenu();
	}, []);

	const getResultCount = function () {
		const count = settings.postsPerPage * state.currentPage;

		return count < state.postsCount ? count : state.postsCount;
	};

	function openModal() {
		const mainModal = document.querySelector('.tf-mobile-modal');
		mainModal.classList.add('active');
	}

	function closeModal() {
		const mainModal = document.querySelector('.tf-mobile-modal');
		mainModal.classList.remove('active');
	}

	function mobileMenu() {
		const closeAllButtons = document.querySelectorAll('.tf-close-all');
		const localCloseButtons = document.querySelectorAll('.tf-close');
		const mainModal = document.querySelector('.tf-mobile-modal');
		const filterModals = document.querySelectorAll(
			'.tf-datepicker, .tf-taxonomy'
		);
		const filterButtons = document.querySelectorAll('.tf-mobile-button');

		//Mobile Close Everything
		if (closeAllButtons && mainModal) {
			closeAllButtons.forEach((closeAllButton) => {
				closeAllButton.addEventListener('click', function () {
					if (filterModals) {
						filterModals.forEach((filterModal) => {
							filterModal.classList.remove('active');
						});
					}

					closeModal();
					mainModal.classList.remove('active');
				});
			});
		}

		//Mobile Close Filters
		if (filterModals && localCloseButtons) {
			localCloseButtons.forEach((localCloseButton) => {
				localCloseButton.addEventListener('click', function () {
					localCloseButton.parentElement.parentElement.parentElement.classList.remove(
						'active'
					);
				});
			});
		}

		//Mobile Open Filters
		if (filterButtons) {
			filterButtons.forEach((filterButton) => {
				filterButton.addEventListener('click', function () {
					filterButton.parentElement.classList.toggle('active');
				});
			});
		}
	}

	return (
		<div className="trip-finder">
			<div className="tf-sidebar">
				<div className="tf-sidebar__top">
					<div
						className="tf-sidebar__clear-title has-overline-font-size"
						onClick={() => dispatch({ type: 'resetFilters' })}
					>
						Clear Filters
					</div>
				</div>
				<Search />

				<div className="tf-mobile-modal">
					<div className="tf-mobile-modal-content">
						<div className="tf-mobile-title">
							<span className="tf-label">Filter</span>
							<button className="tf-close-all"></button>
						</div>

						<Taxonomies />
						<DatePicker />
					</div>

					<div className="mobile-only-nav">
						<span
							className="mobile-only-nav__clear"
							onClick={() => dispatch({ type: 'resetFilters' })}
						>
							Clear All
						</span>
						<span
							className="mobile-only-nav__results"
							onClick={() => closeModal()}
						>
							See Results
						</span>
					</div>
				</div>

				<button
					className="tf-mobile-modal-toggle"
					onClick={() => openModal()}
				>
					Filter By
				</button>
			</div>

			<div className="tf-main">
				<SortBy />
				<Posts />
				<NoResults />
				<LoadMore />
			</div>
		</div>
	);
}

const tripFinder = document.getElementById('trip-finder');

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (tripFinder) {
			// console.log('not null');
			ReactDOM.render(
				<DataProvider>
					<TripFinder />
				</DataProvider>,
				tripFinder
			);
		} else {
			// console.log('null');
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
